import { search } from 'assets/Icons'
import { Icon } from 'assets/index'
import { Container, SearchBar } from './style'

interface ISearchBarComponentProps {
  onChange: any
  placeholder: string
  width?: 'large' | 'small' | 'medium' | 'mediumSmall'
  dataTestId: string
  disabled?: boolean
  isClearable?: boolean
  onClear?: () => void
  value?: string
}

export default function SearchBarComponent(props: ISearchBarComponentProps) {
  const {
    onChange,
    placeholder,
    width,
    dataTestId,
    disabled,
    isClearable,
    onClear,
    value,
  } = props
  return (
    <Container width={width} disabled={disabled}>
      <img className="sb-img" src={search} alt="search icon" />
      <SearchBar
        onChange={onChange}
        placeholder={placeholder}
        data-testid={dataTestId}
        disabled={disabled}
        value={value}
      />
      {isClearable && value && !disabled && (
        <button
          type="button"
          onClick={onClear}
          className="clear-btn"
          data-testid={`${dataTestId}-clear`}
        >
          <img
            src={Icon('error.svg')}
            alt="clear icon"
            className="clear-icon"
          />
        </button>
      )}
    </Container>
  )
}
